import React from "react"
import { graphql } from "gatsby"

import Layout from "@/components/Layout"
import SEO from "@/components/SEO"
import VideoPage, { VideoType } from "@/components/VideoPage"
import { routes } from "@/utils/routes"

type PageProps = {
  data: {
    sanityVideo: VideoType
  }
}

export const pageQuery = graphql`
query Video6Query {
  sanityVideo(position: {eq: 6}) {
    title
    description
    videoUrl
    placeholder {
      asset {
        url
      }
    }
  }
}
`
const Video6: React.FC<PageProps> = ({ data }) => (
    <Layout
      sectionOne={
        <>
          <video
            id="bgvid"
            className="absolute inset-0 w-full h-full object-cover -z-50 sm:hidden"
            playsInline
            autoPlay
            muted
            loop
          >
            <source src="https://rbai-foundation.s3-eu-west-1.amazonaws.com/videos/2025/rbai_giving_day_mobile.mp4" type="video/mp4" />
          </video>
          <video
            id="bgvid"
            className="absolute inset-0 w-full h-full object-cover -z-50  hidden sm:block"
            playsInline
            autoPlay
            muted
            loop
          >
            <source src="https://rbai-foundation.s3-eu-west-1.amazonaws.com/videos/2025/rbai_giving_day.mp4" type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-[#131312]/50 -z-40"></div>
          <div className="container text-white h-[62vh] md:h-[67vh] flex items-center px-4">
            <div className="pl-2 md:pl-6 lg:pl-10 max-w-[1000px] translate-y-[10%] md:translate-y-[5%] lg:translate-y-[0%]">
              <div className="pb-4">
                <h1 className="text-left text-white text-[300%] sm:text-[400%] md:text-[531.25%] leading-[1] font-gilroy font-bold normal-case tracking-normal">Nolan Meets...</h1>
                <div className="mt-5 h-[8px] sm:h-[10px] w-[200px] sm:w-[320px] bg-primary"></div>
              </div>
            </div>
          </div>
        </>
      }
    >
      <SEO title={data.sanityVideo.title} />

      <div className="bg-primary w-full h-[33vh] md:h-auto md:block">
        <div className="flex flex-col h-full w-full md:grid md:grid-cols-4 md:gap-0 md:items-stretch md:min-h-[84px]">
          <a href={routes.socialMobility()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
            Transformative Bursaries
          </a>
          <a href={routes.southWingDevelopment()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
            The South Wing
          </a>
          <a href={routes.pledge()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
            Sponsor a Paviour
          </a>
          <a href={routes.donate()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] text-[19px] leading-[32.3px] md:px-2">
            Donate
          </a>
        </div>
      </div>

      <VideoPage video={data.sanityVideo} />
    </Layout>
  )


export default Video6
